import React, { useState } from "react";
import { FaAngleDown, FaAngleUp } from "react-icons/fa6";
import question from "../../assets/question.png"
import {homequestionData} from "../../demodata/Question"


const Questions = () => {
  const [openIndex, setOpenIndex] = useState(null); 

  const toggleVisibility = (id) => {
    setOpenIndex(openIndex === id ? null : id); 
  };

  return (
    <div className="w-full bg-[#00294B] flex flex-col justify-center items-center py-[4rem]">
      <h2 className="sm:text-5xl text-3xl font-bold text-white text-center py-[2rem] px-4 lg:px-0">
        প্রয়োজনীয় প্রশ্ন এবং উত্তর
      </h2>
      <div className="xl:w-[1296px] w-full flex lg:flex-row flex-col gap-4 lg:mt-[4rem] mt-[2rem]">
        <div className="lg:w-1/2 w-full flex flex-col gap-1">
          {homequestionData.map((item) => (
            <div key={item.id} className="w-full flex flex-col gap-2 p-1">
              <div className={`flex justify-between items-center rounded-md p-3 cursor-pointer ${openIndex === item.id && "border-2 border-[#043B55] "}`} onClick={() => toggleVisibility(item.id)} >

                <h2 className={`text-xl font-semibold  ${openIndex === item.id ? "text-[#22BEFF]":"text-[#abc7b9]"}`}>
                  {item.header}
                </h2>

                <span className="text-xl text-[#22BEFF]">
                  {openIndex === item.id ? <FaAngleUp /> : <FaAngleDown />}
                </span>
              </div>

              {/* Only show <p> tag if this item is open */}
              {openIndex === item.id && (
                <p className="text-base font-normal text-[#abc7b9] pl-2">{item.text}</p>
              )}
            </div>
          ))}
        </div>
        <div className="lg:w-1/2 w-full">
          
          <img src={question} alt="hfhfh" loading="lazy" />
        
        </div>
      </div>
    </div>
  );
};

export default Questions;
